import type { FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";
import { Card, Flex, Image, Text } from "@huub-web/ui";

import { borders } from "@huub-web/ui/theme/css/borders.css";

import { contentStyle, imageStyle } from "./RealtorCard.css";

export type RealtorCardProps = {
  image?: string;
  name: string;
  body: string;
  url?: string;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const RealtorCard: FC<RealtorCardProps> = ({
  image,
  name,
  body,
  ref,
}) => (
  <Card ref={ref} edgeDirection="horizontal" contentClassName={contentStyle}>
    {image && (
      <Image
        src={image}
        alt={name}
        className={mergeClasses(imageStyle, borders.default)}
      />
    )}
    <Flex grow direction="column" gap="s">
      <Text bold>Over {name}</Text>
      <Text color="currentColor50" markdown>
        {body}
      </Text>
    </Flex>
  </Card>
);
